import { render, staticRenderFns } from "./CollectionPool.vue?vue&type=template&id=47d95ac2&scoped=true&"
import script from "./CollectionPool.vue?vue&type=script&lang=js&"
export * from "./CollectionPool.vue?vue&type=script&lang=js&"
import style0 from "./CollectionPool.vue?vue&type=style&index=0&id=47d95ac2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d95ac2",
  null
  
)

export default component.exports